
import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { fabric } from 'fabric';
import _ from 'lodash';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { buttonTypes, componentName, ShapeTypeEnum } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig,InputImages } from 'src/app/shared/dynamicform/models/common-models';
import { operationType, SlottingMode } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { LayoutService } from '../layout.service';
import { ReservationService } from '../reservation.service';

@Component({
    selector: 'app-tables-layout',
    templateUrl: './tables-layout.component.html',
    styleUrls: ['./tables-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TablesLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  seatSelectionFormGp: UntypedFormGroup;
  dataToBePushed = [];
  @ViewChild('canvasLoader') canvasLoader: ElementRef;
  @ViewChild('form') dynamicForm: DynamicFormComponent;
  subscriptions: Subscription = new Subscription();
  seatSelectionConfig: FieldConfig[];
  canvas: any;
  tableObj: any = []
  rectangle: any;
  circle: any;
  ellipse: any;
  pin: any;
  isCommunalTableSelected = false;
  animationCounter = 0;
  topMinValue: any;
  leftMinValue: any;
  bgImage: string;
  tableSelectIcon: any;
  allowMultipleSelection = false;
  scaleFactorY = 1;
  scaleFactorX = 1;
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  total: number = 0;
  customImages: InputImages[] = [];
  layoutImages: InputImages[] = [];
  objectImages: InputImages[] = [];
  shapeTypeEnum = {
    0: 'rect',
    1: 'circle',
    2: 'pin'
  };
  selectedTableIds = [];
  joinTableSelected = [];
  communalTableOption = false;
  basicRectangle: fabric.Rect;
  basicCircle: fabric.Circle;
  isMouseDown = false;
  floorPlanData;
  partyDetails: any;
  editButton: ButtonValue;
  image: any;
  heightValue;
  widthValue;
  isSlotAcquired = false;
  timerSubscription: Subscription = new Subscription();
  constructor(public ls: LayoutService, private fb: UntypedFormBuilder, private rs: ReservationService, private ts: TranslateService, public gs: GuestService) {
  }

  ngOnInit() {
    let that = this;
    this.communalTableOption = this.rs.reservationFormGroup.controls.reservationDetailsForm.value.communalAvailability;
    this.allowMultipleSelection = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowMultipleTableSelection
    this.seatSelectionFormGp = this.fb.group({
      seatSelected: ''
    });
    this.subscriptions.add(this.ls.restaurantImages.subscribe((images) => {
      if (images) {
        this.layoutImages = images.LayoutImages;
        this.objectImages = images.ObjectImages;
        this.customImages = images.CustomImages;
      }
    }))
    this.seatSelectionConfig = [
      {
        type: 'input',
        name: 'partySize',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('partySize'),
        class: "tables-layout__party-size",
        value: ''
      },
      {
        type: 'date',
        name: 'reservationDate',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('date'),
        class: "tables-layout__date"
      },
      {
        type: 'input',
        name: 'seatingArea',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('seatingArea'),
        class: "tables-layout__seating-area",
        value: ''
      },
      {
        type: 'input',
        name: 'seatingType',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('seatingType'),
        class: "tables-layout__seating-type",
        value: ''
      },
      {
        type: 'input',
        name: 'reservationTime',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('time'),
        class: "tables-layout__date"
      }
    ];

    this.ls.isCommunalTableSelected = false;
    //let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    //control.get('tableId').setValue([]); // clear the table ids in the form
    let reservationData = this.rs.reservationFormGroup.controls.reservationDetailsForm.value;
    this.rs.selectedSpecialMealId$.next(reservationData.specialMeal?.Id || null);
    this.subscriptions.add(this.rs.getLayoutData(this.ls.restaurantWidgetSettings$.value.RestaurantId,
      reservationData.partySize,
      reservationData.communalAvailability,
      moment(reservationData.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),
      reservationData.seatingArea.id > 0 ? reservationData.seatingArea.id : null,
     // this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 ? this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id : null,
      null,
      this.ls.operation == operationType.edit ? this.ls.editPartyData$.value.Id : null,
      (reservationData?.specialMeal?.Id || null)
    ).subscribe(response => {
      this.floorPlanData = response.Payload.FloorPlans[0];
      this.setDefaultFloor(this.floorPlanData.StandaloneTables, this.floorPlanData.Labels, this.floorPlanData.Walls, this.floorPlanData.Shapes, this.floorPlanData.ImageId);
      if (this.rs.lockCallRequired) {
        this.LockSlot();
      }
      else {
        this.isSlotAcquired = true;
        this.highLightSelectedTables();
        this.controlTimerDisplay();
      }
    }));

    this.editButton = {
      type: buttonTypes.confirmBtn,
      label: 'edit',
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: false
    };
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: 'next',
      customclass: 'tables-layout__next-btn',
      disbaledproperity: true
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: 'previous',
      customclass: 'tables-layout__previous-btn',
    };
    this.partyDetails = _.cloneDeep(this.rs.reservationFormGroup.controls.reservationDetailsForm.value);
    this.ls.editPartyData = _.cloneDeep(this.rs.reservationFormGroup.controls.reservationDetailsForm.value);
    fabric.Pin = fabric.util.createClass(fabric.Circle, {

      type: 'pin',
      _render: function (ctx) {
        this.callSuper('_render', ctx);
        ctx.font = this.radius * 2 + 'px Arial';
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        ctx.fillText(this.label, 0, this.radius - 4);
      }
    });

    fabric.Pin.fromObject = function (object, callback, forceAsync) {

      return fabric.Object._fromObject('Pin', object, callback, forceAsync);
    }
    fabric.loadSVGFromURL('assets/images/check.svg', function (objects, options) {
      that.tableSelectIcon = fabric.util.groupSVGElements(objects, options);
    });

    fabric.Text.prototype.set({
      _getNonTransformedDimensions() { // Object dimensions
        return new fabric.Point(this.width, this.height).scalarAdd(this.padding);
      },
      _calculateCurrentDimensions() { // Controls dimensions
        return fabric.util.transformPoint(this._getTransformedDimensions(), this.getViewportTransform(), true);
      }
    });

  }

  skipOrHightLightTableSelection() {
    if (!this.isTableAvailable(this.floorPlanData) && SlottingMode[this.ls.restaurantWidgetSettings$.value.SlottingModeWidget] == SlottingMode.Manual) {
      let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
      control.get('tableId').setValue([]);
      this.ls.nextButton.next(componentName.guestDetails)
    }
    else {
      this.highLightSelectedTables();
    }
  }

  highLightSelectedTables() {
    if (this.ls.editPartyData && this.ls.editPartyData.tableId && this.ls.editPartyData.tableId.length > 0) {
      this.highlightPreviousSelectedTable(this.ls.editPartyData.tableId);

    }
    else if (this.ls.operation == operationType.edit && this.ls.editPartyData$.value && this.ls.editPartyData$.value.TableIds && this.ls.editPartyData$.value.TableIds.length > 0) {
      this.highlightPreviousSelectedTable(this.ls.editPartyData$.value.TableIds);
    }
  }

  highlightPreviousSelectedTable(tableIds: any[]) {
    this.selectedTableIds = []

    const objs = this.canvas.getObjects();
    tableIds.forEach(tableId => {
      let tableObj = objs.filter(x => x.Id == tableId &&
        (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id == 0
          || x.SeatingTypeId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id) &&
        (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0
          || x.SeatingAreaId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id))[0];

      if (tableObj) {
        //this.setSelectedTables(tableObj);
        this.selectedTableIds.push(tableId);
        this.animationCounter = 0;
        // let rectangle = this.addHighLightObject(tableObj);
        // this.animateObject(rectangle, 0, 0);
        this.highlightSelectedObject(tableObj);
      }
    });
    this.canvas.renderAll();
    this.rs.reservationFormGroup.controls.reservationDetailsForm.value.tableId = this.selectedTableIds;
    let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    control.get('tableId').setValue(this.selectedTableIds);

  }

  getReservationId(): number{
    return this.ls?.editPartyData$?.value?.Id;
  }

  LockSlot() {
    let reservationData = this.rs.reservationFormGroup.controls.reservationDetailsForm.value;
    let lockSlotDto = {
      LocalTime: moment(reservationData.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),  //selected date and time
      PartySize: reservationData.partySize,
      SeatingAreaId: reservationData.seatingArea.id > 0 ? reservationData.seatingArea.id : null,
      SeatingTypeId: reservationData.seatingType.id > 0 ? reservationData.seatingType.id : null,
      IsCommunalTable: reservationData.communalAvailability,
      FromWebsite: true,
      SpecialMealId:reservationData.specialMeal?.Id || null,
      ReservationIdToIgnore: this.getReservationId() || null
    }
    this.subscriptions.add(this.rs.GetLockSlot(this.ls.restaurantWidgetSettings$.value.RestaurantId, lockSlotDto).subscribe(data => {
      if (data && data.SlotLockIdDTO) {
        //configure Timer
        this.gs.setMessageState('', 0);
        this.ls.lockResult = data;
        let timer = moment(data.ExpiresAt).diff(moment(data.LockedAt), "seconds");
        this.ls.showTimer = true;
        this.ls.runTimer(timer);
        this.isSlotAcquired = true;

        if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0 && data.SeatingAreaId > 0 ) { //slot seating Area Id Locked
          let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
          control.get('seatingArea').setValue({ id: data.SeatingAreaId, name: this.ls.restaurantWidgetSettings$.value.SeatingAreaList.filter(x => x.Id == data.SeatingAreaId)[0].Name }, { emitEvent: false });
          this.partyDetails.seatingArea = _.cloneDeep({ id: data.SeatingAreaId, name: this.ls.restaurantWidgetSettings$.value.SeatingAreaList.filter(x => x.Id == data.SeatingAreaId)[0].Name })
        }
        this.skipOrHightLightTableSelection();
      }
      else {
        this.isSlotAcquired = false;
        this.gs.setMessageState(this.ts.instant('SlotIsNotFound'), 0);
      }

      this.controlTimerDisplay();
    }));
  }

  controlTimerDisplay() {
    let timeCount = 0;
    this.timerSubscription = interval(1000 * 1).subscribe(() => {
      timeCount++;
      if (timeCount % 10 == 0) {
        this.ls.showTimer = !this.ls.showTimer;
      }
    });

  }


  getGuestDetails() {
    this.updateSeatingTypeId(this.floorPlanData);
    this.ls.showTimer = true;
    this.ls.nextButton.next(componentName.guestDetails);
  }

  getReservationDetails() {
    if (this.ls.lockResult && this.ls.lockResult.SlotLockIdDTO) {
      this.rs.ReleaseLockSlot(this.ls.restaurantWidgetSettings$.value.RestaurantId, this.ls.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.ls.offTimer();
        this.ls.nextButton.next(componentName.reservationDetails);
      });
    }
    else {
      this.ls.nextButton.next(componentName.reservationDetails);
    }
  }

  updateSeatingTypeId(floorPlanData) {
    let selectedTableId = this.rs.reservationFormGroup.controls.reservationDetailsForm.value.tableId;
    let selectedSeatingType = floorPlanData.StandaloneTables.filter(t => t.Id == selectedTableId[0])[0].SeatingTypeId;
    let selectedSeatingArea = floorPlanData.StandaloneTables.filter(t => t.Id == selectedTableId[0])[0].SeatingAreaId;
    let isSameType: boolean = true;
    let isSameArea: boolean = true;
    selectedTableId.forEach(table => {
      isSameType = floorPlanData.StandaloneTables.filter(t => t.Id == table)[0].SeatingTypeId == selectedSeatingType && isSameType;
      isSameArea = floorPlanData.StandaloneTables.filter(t => t.Id == table)[0].SeatingAreaId == selectedSeatingArea && isSameType;
    });
    this.ls.isCommunalTableSelected = floorPlanData?.StandaloneTables?.filter(t => selectedTableId.includes(t.Id) && !t.IsCommunalTable).length == 0;

    // if (isSameType
    //   && selectedSeatingType > 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id == 0
    //   && selectedSeatingArea > 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0) {
    //   let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    //   control.get('seatingType').setValue({ id: selectedSeatingType, name: this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == selectedSeatingType)[0].Description }, { emitEvent: false });

    //   //  control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    //   // control.get('seatingArea').setValue({ id: selectedSeatingArea, name: this.ls.restaurantWidgetSettings$.value.SeatingAreaList.filter(x => x.Id == selectedSeatingArea)[0].Name }, { emitEvent: false });
    // }
    // else

    if(isSameType
      && selectedSeatingType > 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id == 0){
        let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
      control.get('seatingType').setValue({ id: selectedSeatingType, name: this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == selectedSeatingType)[0].Description }, { emitEvent: false });
    }

  }

  ngAfterViewInit() {
    this.setCanvas();
    this.subscriptions.add(this.rs.reservationFormGroup.controls.reservationDetailsForm.valueChanges.subscribe(x => {
      this.nextButton.disbaledproperity = (!x.tableId || x.tableId.length == 0) || !this.isSlotAcquired
    }));

  }

  isSelectedSizeAccommodableInTable(floorPlanData): boolean {
    let index = floorPlanData.StandaloneTables.findIndex(table => table.MaxPartySize >= this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize
      && table.IsAvailableForBooking && table.IsAvailableForReservations)
    return index > -1;
  }

  isJoinedTableAvailable(tableId): any[] {
    let joinedTables = [];
    let isStandaloneTableAvailable = this.isSelectedSizeAccommodableInTable(this.floorPlanData);
    if (isStandaloneTableAvailable) {
      return joinedTables;
    }
    else {
      if (this.floorPlanData.JoinedTables && this.floorPlanData.JoinedTables.length > 0) {
        this.floorPlanData.JoinedTables.forEach(joinedTable => {
          if (joinedTable.StandaloneTableIds.findIndex(x => x == tableId) > -1 && joinedTable.MaxPartySize >= this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.partySize >= joinedTable.MinPartySize) {
            let tablesJoined = [];
            let seatingAreaId = this.floorPlanData.StandaloneTables.filter(table => table.Id == joinedTable.StandaloneTableIds[0])[0].SeatingAreaId;
            let seatingTypeId = this.floorPlanData.StandaloneTables.filter(table => table.Id == joinedTable.StandaloneTableIds[0])[0].SeatingTypeId;
            joinedTable.StandaloneTableIds.forEach(Id => {
              let tableReq = this.floorPlanData.StandaloneTables.filter(table => table.Id == Id && table.SeatingAreaId == seatingAreaId && table.SeatingTypeId == seatingTypeId)[0];
              if (tableReq) {
                tablesJoined.push(tableReq);
              }
            });
            if (tablesJoined.length > 0 && tablesJoined.length == joinedTable.StandaloneTableIds.length) {
              joinedTables = [...tablesJoined];
            }
          }
        });
      }
    }
    return joinedTables;
  }

  isTableAvailable(floorPlanData): boolean {
    if (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id == 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0) {
      return true;
    }
    let index = floorPlanData.StandaloneTables.findIndex(table => (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id == 0 || !(table.SeatingTypeId > 0) || table.SeatingTypeId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
      && (this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id == 0 || table.SeatingAreaId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id)
      && table.IsAvailableForBooking && table.IsAvailableForReservations)
    return index > -1;
  }


  baseElement;
  setCanvas() {
    this.baseElement = this.canvasLoader.nativeElement;
    this.canvas = new fabric.Canvas('tablesLayout', {
      selection: false,
    });
    this.canvas.preserveObjectStacking = true;
    fabric.Object.prototype.set({
      transparentCorners: false,
      rotatingPointOffset: 20,
      cornerSize: 12,
      hasBorders: false,
      lockMovementX: true,
      lockMovementY: true,
      perPixelTargetFind: true,
      flipY: false,
      hasControls: false
    });

    this.canvas.hoverCursor = 'pointer';
    this.canvas.perPixelTargetFind = true;
    this.canvas.targetFindTolerance = 2;
    let _that = this;


    this.canvas.on({
      'mouse:down'(event) {
        _that.mouseOut(event, _that);
        _that.showPrice(event, _that);
        if (event.target && (
          !(event.target.SeatingTypeId > 0)
          || !(_that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0)
          || (event.target.SeatingTypeId > 0 && _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 && event.target.SeatingTypeId == _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
        ) && (
            !(event.target.SeatingAreaId > 0)
            || !(_that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0)
            || (event.target.SeatingAreaId > 0 && _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 && event.target.SeatingAreaId == _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id)
          )) {
          _that.setSelectedTables(event);
        }
        //_that.removeIllusion();


      },
      'mouse:move'(event) {
        if (!_that.isMouseDown) {
          _that.removeHightLightColor(event, _that);
        }
      },
      'mouse:up'(event) {
        _that.removeHightLightColor(event, _that);

      },
      'mouse:over'(event) {
        // _that.showPrice(event, _that)
      },
      'mouse:out'(event) {
        // _that.mouseOut(event, _that)
      }

    });


  }

  mouseOut(event, _that) {
    _that.canvas.remove(_that.canvas.getObjects().filter(x => x.name == 'pricePopover')[0])
  }

  addHighLightObject(table) {
    let shape = table.getObjects().filter(x => x.name == 'shape')[0];
    let serverData = table.getObjects().filter(x => x.name == 'serverCircle');
    let join = table.getObjects().filter(x => x.name == 'join');
    let notes = table.getObjects().filter(x => x.name == 'notes');
    let shapetype = shape.get('type');
    let icontop = (table.top) + ((table.height * table.scaleY) / 2);
    let iconleft = table.left - ((table.width * table.scaleX) / 2);
    if (shapetype == "circle") {

      let x = shape.radius * Math.sin(Math.PI * 2 * 45 / 360);
      let y = shape.radius * Math.cos(Math.PI * 2 * 45 / 360);
      let newval = join && join.length > 0 || notes && notes.length > 0 || shape.radius <= 10 ? 10 : 3;
      let notesval = notes && notes.length > 0 && shape.radius <= 10 ? 8 : shape.radius <= 10 ? 3 : 0;
      icontop = (icontop - newval) - (y / 2);
      iconleft = iconleft + notesval + (x / 2) - ((shape.radius / 25) * 5);

    } else if (shapetype == 'ellipse') {


      let x = shape.rx * Math.sin(Math.PI * 2 * 45 / 360);
      let y = shape.ry * Math.cos(Math.PI * 2 * 45 / 360);
      if (shape.angle) {
        x = shape.rx * Math.sin(Math.PI * 2 * shape.angle / 360);
        y = shape.ry * Math.cos(Math.PI * 2 * shape.angle / 360);
        y = y < 0 ? -1 * y : y;
      }
      icontop = (icontop) - (y / 2);
      if (shape.angle)
        iconleft = iconleft + 25;
    }
    else {
      icontop = shape.angle ? icontop - 22 : icontop - 10;
      iconleft = join && join.length > 0 ? iconleft + 6 : iconleft;
    }

    let myobj = _.cloneDeep(this.tableSelectIcon);

    myobj.set({
      top: icontop,
      left: iconleft
    });
    myobj.set({
      name: 'highlight',
    });
    myobj.scaleToWidth(20);
    myobj.scaleToHeight(20);
    table.addWithUpdate(myobj);
    this.canvas.renderAll();

    return myobj;
  }

  showPrice(event, _that) {
    var available;
    var price;
    var textAvailable;
    var textSeatingType;
    var textPartySize;
    var statusColor;
    if (event.target && event.target.Id) {
      if ((
        !(event.target.SeatingTypeId > 0)
        || !(_that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0)
        || (event.target.SeatingTypeId > 0 && _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 && event.target.SeatingTypeId == _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
      ) && (
          !(event.target.SeatingAreaId > 0)
          || !(_that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0)
          || (event.target.SeatingAreaId > 0 && _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 && event.target.SeatingAreaId == _that.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id)
        ) && event.target.IsAvailableForReservations && event.target.IsAvailableForBooking && this.partyDetails.partySize >= event.target.MinPartySize) {
        event.target.hoverCursor = 'pointer';
      }
      else {
        event.target.hoverCursor = 'not-allowed';
      }

      if (event.target.IsAvailableForReservations && event.target.IsAvailableForBooking) {
        if (event.target.SeatingAreaId) {
          if (event.target.MinPartySize > this.partyDetails.partySize) {
            if (event.target.SeatingAreaId) {
              available = this.ts.instant('notAvailable');
              price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
              textAvailable = ' ' + available + ' ' + '\n'
              textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
              textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
              statusColor = '#B93535';
            }
          }
          else {
            available = this.ts.instant('available');
            price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
            textAvailable = ' ' + available + ' ' + '\n'
            textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
            textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
            statusColor = '#F27106';
          }
        }
      }
      else if (event.target.IsAvailableForReservations && !event.target.IsAvailableForBooking && !event.target.EventId) {
        if (event.target.SeatingAreaId) {
          available = this.ts.instant('sold');
          price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
          textAvailable = ' ' + available + ' ' + '\n'
          textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
          textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
          statusColor = '#B93535';
        }
      }
      else if (event.target.IsAvailableForReservations && !event.target.IsAvailableForBooking && event.target.EventId) {
        if (event.target.SeatingAreaId) {
          available = this.ts.instant('notAvailable');
          price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
          textAvailable = ' ' + available + ' ' + '\n'
          textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
          textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
          statusColor = '#B93535';
        }
      }
      else if (!event.target.IsAvailableForReservations && event.target.IsAvailableForBooking) {
        if (event.target.SeatingAreaId) {
          available = this.ts.instant('notAvailable');;
          price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
          textAvailable = ' ' + available + ' ' + '\n'
          textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
          textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
          statusColor = '#B93535';
        }
      }
      else if (!event.target.IsAvailableForReservations && !event.target.IsAvailableForBooking) {

        if (event.target.SeatingAreaId) {
          available = this.ts.instant('notAvailable');;
          price = (event.target.Price != null && event.target.Price != "") ? (this.ls.OperationCurrency + Number(event.target.Price).toFixed(this.ls.restaurantWidgetSettings$.value.NumberOfFractionalDigits)) : ('')
          textAvailable = ' ' + available + ' ' + '\n'
          textSeatingType = this.getTableDisplayName(event.target) + '   ' + price;
          textPartySize = event.target.MinPartySize + ' ' + this.ts.instant('min') + '  |  ' + event.target.MaxPartySize + ' ' + this.ts.instant('max');
          statusColor = '#B93535';
        }

      }
      let rect = new fabric.Rect({
        height: 90,
        width: 150,
        cornerSize: 4,
        fill: '#444444',
        rx: 4,
        ry: 4
      });
      let textAvailablerect = new fabric.Rect({

        height: 20,
        width: 110,
        fill: statusColor,
        rx: 4,
        ry: 4,
        originY: 'center',
        originX: 'center',
      })
      let textAvailableData = new fabric.Text(textAvailable, {
        fill: '#fff',
        fontSize: 12,
        fontFamily: 'Roboto-Medium',
        originY: 'center',
        originX: 'center',
        top: textAvailablerect.height / 2 - 2,

      });
      let textAvailableGroup = new fabric.Group([textAvailablerect, textAvailableData], {
        top: rect.height / 2 - 20,
        left: rect.width / 2,
        originY: 'center',
        originX: 'center'
      })


      let textSeatingTypeLabel = new fabric.Text(textSeatingType, {
        top: rect.height / 2,
        left: rect.width / 2,
        fill: '#fff',
        fontSize: 14,
        fontFamily: 'Roboto-Regular',
        textAlign: 'left',
        originY: 'center',
        originX: 'center'
      });
      let data = '';
      if (event.target.IsCommunalTable) {
        data = this.ts.instant('communalSeating');
      }
      else {
        data = textPartySize
      }

      let partySizeData = new fabric.Text(data, {
        top: rect.height / 2 + 25,
        left: rect.width / 2,
        fill: '#fff',
        fontSize: 14,
        fontFamily: 'Roboto-Regular',
        textAlign: 'left',
        originY: 'center',
        originX: 'center'
      });
      let pricePopoverGroup = new fabric.Group([rect, textAvailableGroup, partySizeData, textSeatingTypeLabel], {
        cornerSize: 10,
        name: 'pricePopover',
        top: event.target.top,
        left: event.target.left,
      })

      pricePopoverGroup.top = event.target.top + (event.target.height / 2);
      pricePopoverGroup.left = event.target.left - (pricePopoverGroup.width / 2);
      if ((pricePopoverGroup.top + pricePopoverGroup.height) > _that.canvas.getHeight()) {
        pricePopoverGroup.top = event.target.top - pricePopoverGroup.height - (event.target.height / 2);
      }
      if ((pricePopoverGroup.left + pricePopoverGroup.width) > _that.canvas.getWidth()) {
        pricePopoverGroup.left = event.target.left - pricePopoverGroup.width - (event.target.width / 2);
      }
      if (pricePopoverGroup.left < 0) {
        pricePopoverGroup.left = event.target.left + (event.target.width / 2);
      }
      _that.canvas.add(pricePopoverGroup);
    }

  }

  getTableDisplayName(target): string {
    if (target.SeatingTypeId > 0 && target.SeatingType) {
      return target.SeatingType.toString();
    }
    else {
      return target.Name.toString();
    }
  }

  removeHightLightColor(obj, _that) {
    this.isMouseDown = false;
    const objs = _that.canvas.getObjects();
    objs.forEach(object => {
      object.set('opacity', 1);
    });
  }

  onSelectionCleared(eve, that) {
    that.selectionCleared.emit(eve);
  }

  removeIllusion() {
    let val = this.canvas.getObjects().filter(x => x.name == 'dummy')[0]
    if (val) {
      this.canvas.remove(val);
      return true;
    }
    return false
  }

  setDefaultFloor(tables, labels, walls, shapes, imageId) {
    this.dataToBePushed = [];
    labels.forEach((element, index) => {
      element.id = index;
      element.name = 'label';
    });
    walls.forEach((element, index) => {
      element.id = index;
      element.name = 'wall';
    });

    shapes.forEach((element, index) => {
      element.id = index;
      element.name = 'area';
    });


    tables = _.cloneDeep(tables);
    labels = _.cloneDeep(labels);
    walls = _.cloneDeep(walls);
    shapes = _.cloneDeep(shapes);
    let basicTables = this.findminObject(tables, labels, walls, shapes);
    let topMinValue = _.minBy(basicTables, 'totalminDataHeight');
    let leftMinValue = _.minBy(basicTables, 'totalminDataWidth');
    const negativeCoords = basicTables.filter(x => x.totalminDataHeight < 0 || x.totalminDataWidth < 0);
    this.topMinValue = Math.abs(topMinValue['totalminDataHeight']);
    this.leftMinValue = Math.abs(leftMinValue['totalminDataWidth']);
    if (negativeCoords.length > 0) {
      // negative values
      let adjustedTopValue = topMinValue['totalminDataHeight'] < 0 ? Math.abs(topMinValue['totalminDataHeight']) : 0;;
      let adjustedLeftValue = leftMinValue['totalminDataWidth'] < 0 ? Math.abs(leftMinValue['totalminDataWidth']) : 0;
      tables.forEach(element => {
        element.Top = element.Top + Math.abs(adjustedTopValue);
        element.Left = element.Left + Math.abs(adjustedLeftValue);
      });
      labels.forEach(element => {
        element.Top = element.Top + Math.abs(adjustedTopValue);
        element.Left = element.Left + Math.abs(adjustedLeftValue);
      });
      walls.forEach(element => {
        element.Points.forEach(point => {
          point['X'] = point['X'] + adjustedLeftValue;
          point['Y'] = point['Y'] + adjustedTopValue;
        });
      });

      shapes.forEach(element => {
        element.Top = element.Top + Math.abs(adjustedTopValue);
        element.Left = element.Left + Math.abs(adjustedLeftValue);
      });

      //       // find new min val
      basicTables = this.findminObject(tables, labels, walls, shapes);
      topMinValue = _.minBy(basicTables, 'totalminDataHeight');
      leftMinValue = _.minBy(basicTables, 'totalminDataWidth');
      this.topMinValue = Math.abs(topMinValue['totalminDataHeight']);
      this.leftMinValue = Math.abs(leftMinValue['totalminDataWidth']);

    }
    let adjustedTopValue = 0;
    let adjustedLeftValue = 0;

    if (this.topMinValue > 50 && this.floorPlanData.ImageId == null) {
      adjustedTopValue = -1 * (this.topMinValue - 30);
    } else if (this.floorPlanData.ImageId) {
    }

    if (this.leftMinValue > 50 && this.floorPlanData.ImageId == null) {
      adjustedLeftValue = -1 * (this.leftMinValue - 30);
    } else if (this.floorPlanData.ImageId) {
    }

    tables.forEach(element => {
      element.Top = element.Top + (element.Height / 2) + adjustedTopValue;
      element.Left = element.Left + (element.Width / 2) + adjustedLeftValue;
    });
    labels.forEach(element => {

      let findstringlength = element.Text.length;
      let getwidth = 11;
      let getHeight = 11;
      let angles = element.Angle;
      if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
        getwidth = (findstringlength * 10) / 2;
      } else {
        getHeight = (findstringlength * 10) / 2;
      }
      element.Top = element.Top + adjustedTopValue + getHeight;
      element.Left = element.Left + adjustedLeftValue + getwidth;
    });
    walls.forEach(element => {
      element.Points.forEach(point => {
        point['X'] = point['X'] + adjustedLeftValue;
        point['Y'] = point['Y'] + adjustedTopValue;
      });
    });

    shapes.forEach(element => {
      element.Top = element.Top + adjustedTopValue;
      element.Left = element.Left + adjustedLeftValue;
    });

    basicTables = this.findmaxObject(tables, labels, walls, shapes);
    const topValue = _.maxBy(basicTables, 'totalDataHeight');
    const leftValue = _.maxBy(basicTables, 'totalDataWidth');

    this.heightValue = topValue['totalDataHeight'] + 25;
    this.widthValue = leftValue['totalDataWidth'] + 25;
    const height = this.canvasLoader.nativeElement.clientHeight > this.heightValue ? this.canvasLoader.nativeElement.clientHeight : this.heightValue;
    const width = this.canvasLoader.nativeElement.clientWidth > this.widthValue ? this.canvasLoader.nativeElement.clientWidth : this.widthValue;
    let scaleFactor;
    if (this.canvas) {
      this.scaleFactorY = this.canvasLoader.nativeElement.clientHeight / this.heightValue;
      this.scaleFactorX = this.canvasLoader.nativeElement.clientWidth / this.widthValue;
      if (this.scaleFactorX < 1 && this.scaleFactorY < 1) {
        scaleFactor = this.scaleFactorX <= this.scaleFactorY ? this.scaleFactorX : this.scaleFactorY;
      }
      else {
        scaleFactor = this.scaleFactorX >= this.scaleFactorY ? this.scaleFactorY : this.scaleFactorX;
      }

      let calculatedWidth = width * scaleFactor;
      //  this.canvas.setZoom(scaleFactor);
      this.canvas.setHeight(this.canvasLoader.nativeElement.clientHeight);
      this.canvas.setWidth(this.canvasLoader.nativeElement.clientWidth);
    }
    let _that = this;
    let floorPlanImage = this.layoutImages.filter(x => x.ImageId == imageId)[0];
    fabric.Image.fromURL(floorPlanImage ? 'data:image/png;base64,' + floorPlanImage.bytes : '', function (img) {
      _that.canvas.setBackgroundImage(img, _that.canvas.renderAll.bind(_that.canvas), {
        scaleX: _that.canvas.width / img.width,
        scaleY: _that.canvas.height / img.height
      });
    });
    //     //   this.renderer.setStyle(this.canvasLoader.nativeElement, 'height', this.height);
    //     //  this.renderer.setStyle(this.canvasLoader.nativeElement, 'width', this.width)
    tables.forEach(element => {
      this.setTableConfiguration(element);

    });
    this.dataToBePushed.forEach(data => {
      this.canvas.add(data);
      data.set('subTargetCheck', true);
    })

    if (labels) {
      labels.forEach((element, index) => {
        this.addLabel(element, index);
      });

    }
    if (shapes) {
      shapes.forEach(element => {
        this.addShape(element);
      });

    }
    if (walls) {
      walls.forEach(element => {
        this.addWall(element);
      });
    }

    const objs = this.canvas.getObjects();

    objs.forEach((table) => {
      if (table.ImageId && (table.ShapeType == 3 || table.ShapeType == 4)) {
        this.setObjectImage(table);
      }
    });
    //Needed
    if (this.floorPlanData.ImageId) {
      if (this.floorPlanData.Dimensions && this.floorPlanData.Dimensions.length > 0 && this.floorPlanData.Dimensions[0].Width > 0 && this.floorPlanData.Dimensions[0].Height > 0) {
        this.scaleFactorX = this.canvasLoader.nativeElement.clientWidth / this.floorPlanData.Dimensions[0].Width;
        this.scaleFactorY = this.canvasLoader.nativeElement.clientHeight / this.floorPlanData.Dimensions[0].Height;
        this.canvas.getObjects().forEach(element => {
          element.set({
            scaleX: element.scaleX * _that.scaleFactorX,
            scaleY: element.scaleY * _that.scaleFactorY,
            top: element.top * _that.scaleFactorY,
            left: element.left * _that.scaleFactorX
          })
          element.setCoords();
        });
      }
      else {
        this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlanData.BasedOn)
      }
      // if (isScalingAvailable) {
      //   this.lf.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlan.BasedOn);
      // }
    } else {
      this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlanData.BasedOn);
    }
    //this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor);
    this.canvas.renderAll();
  }

  setObjectImage(table) {
    let selectedTableObject = this.canvas.getObjects().filter(tableObj => tableObj.Id == table.Id);
    let tableImage = this.objectImages.filter((img) => img.ImageId == table.ImageId);

    if (selectedTableObject && selectedTableObject.length > 0 && tableImage.length > 0) {
      let compressedPhoto;
      fabric.Image.fromURL('data:image/png;base64,' + tableImage[0].bytes, (img) => {
        compressedPhoto = img;
        let shapedObject = selectedTableObject[0]._objects.filter(ele => ele.name == 'shape')[0];
        if (selectedTableObject[0].ShapeType == 4) {
          compressedPhoto.set({
            scaleX: (((shapedObject.width) / img.width) * selectedTableObject[0].scaleX),
            scaleY: (((shapedObject.height) / img.height) * selectedTableObject[0].scaleY),
            top: selectedTableObject[0].top,
            left: selectedTableObject[0].left,
            originX: 'center',
            originY: 'center',
            name: 'image',
            width: img.width,
            height: img.height,
          })
        } else {
          compressedPhoto.set({
            scaleX: ((shapedObject.width) / img.width) * selectedTableObject[0].scaleX,
            scaleY: ((shapedObject.height) / img.height) * selectedTableObject[0].scaleY,
            top: selectedTableObject[0].top,
            left: selectedTableObject[0].left,
            originX: 'center',
            originY: 'center',
            name: 'image',
            width: img.width,
            height: img.height
          });
          let server = selectedTableObject[0]._objects.filter(ele => ele.name == 'serverCircle');
          if (server && server.length > 0) {
            server[0].left = server[0].left + 12;
            server[0].top = server[0].top - 13;
          }
        }
        let allObjects = selectedTableObject[0]._objects.filter(ele => ele.name == 'textCircle' ||
          ele.name == 'tableNumber' || ele.name == 'text' || ele.name == 'serverLines').length;

        selectedTableObject[0].addWithUpdate(compressedPhoto);
        if (selectedTableObject[0].ShapeType == 4) {
          selectedTableObject[0].set({
            clipPath: new fabric.Circle({
              radius: selectedTableObject[0].height / 2,
              originX: 'center',
              originY: 'center',
              startAngle: 0,
              angle: Math.PI * 2,
            }),
          })
        }
        compressedPhoto.moveTo(selectedTableObject[0].size() - (allObjects + 1));
        selectedTableObject[0].addWithUpdate();
        this.canvas.renderAll();
      })
    }
  }


  addLabel(obj, index) {
    obj.id = index;
    obj.name = 'label';
    this.canvas.add(new fabric.Text(obj.Text.toString(), {
      fontFamily: 'Roboto Light',
      left: obj.Left,
      top: obj.Top,
      fontSize: 20,
      fontWeight: 'bold',
      fill: '#0000008A',
      data: index,
      name: 'label',
      selectable: false,
      angle: obj.Angle,
      originX: 'center',
      originY: 'center'
    }));
    this.canvas.renderAll();
  }
  addShape(element) {
    let shape;
    let newcolor = element.Color ? 'rgba(' + element.Color.R + ',' + element.Color.G + ',' + element.Color.B + ',' + element.Color.A + ')' : '#3B4532'
    if (element.ShapeType != undefined) {
      let type;
      switch (element.ShapeType) {
        case 0:
          type = ShapeTypeEnum.Rectangle
          break;
        case 1:
          type = this.checkTableiscircle(element);
          break;
        case 2:
          type = this.checkTableiscircle(element);
          break
      }
      if (type == ShapeTypeEnum.Rectangle) {
        shape = new fabric.Rect({
          left: element.Left,
          top: element.Top,
          height: element.Height,
          width: element.Width,
          stroke: newcolor,
          strokeWidth: 2,
          strokeDashArray: [8, 3],
          name: 'area',
          fill: '',
          angle: element.Rotation,
          selectable: false
        });
      } else if (type == ShapeTypeEnum.Circle) {

        shape = new fabric.Circle({
          radius: (element.Width > element.Height ? element.Height : element.Width) / 2,
          left: element.Left,
          top: element.Top,
          height: element.Height,
          width: element.Width,
          stroke: newcolor,
          strokeWidth: 2,
          strokeDashArray: [8, 3],
          name: 'area',
          fill: 'transparent',
          angle: element.Rotation,
          perPixelTargetFind: true,
        });
      } else if (type == ShapeTypeEnum.Ellipse) {

        shape = new fabric.Ellipse({
          left: element.Left,
          top: element.Top,
          rx: element.Width / 2,
          ry: element.Height / 2,
          stroke: newcolor,
          strokeWidth: 2,
          strokeDashArray: [8, 3],
          name: 'area',
          fill: 'transparent',
          angle: element.Rotation,
          perPixelTargetFind: true,
        });

      }
    }
    this.canvas.add(shape)
    this.canvas.sendToBack(shape);
    this.canvas.renderAll();
  }

  addWall(element) {
    element.name = 'wall'
    let linesArray = []
    element.Points.forEach(point => {
      linesArray.push({ x: point.X, y: point.Y })
    });

    let wall = new fabric.Polyline(linesArray, {
      stroke: '#3B4532',
      strokeWidth: 2,
      fill: 'transparent',
      data: element.id,
      name: 'wall',
      perPixelTargetFind: true,

    });
    this.canvas.add(wall)
    this.canvas.sendToBack(wall);
    this.canvas.renderAll();
  }



  scaleObjects(canvas, scaleFactorX, scaleFactorY, scaleFactor, BasedOn?) {
    const objects = canvas.getObjects();
    for (const i in objects) {
      const scaleX = objects[i].scaleX;
      const scaleY = objects[i].scaleY;
      const left = objects[i].left;
      const top = objects[i].top;
      const shapetype = objects[i].name == 'area';
      let scalefactorneed = false;
      if (objects[i]._objects) {
        let shape = objects[i]._objects.filter(x => x.name == 'shape')[0];
        let shapetypetable = shape.get('type');
        scalefactorneed = false;
        if (!shapetype && shapetypetable == ShapeTypeEnum.Rectangle && BasedOn == undefined) {
          scalefactorneed = this.getbigRectangle(objects[i].width, objects[i].height);
        }
      }
      const tempScaleX = scaleX * (shapetype || scalefactorneed ? scaleFactorX : scaleFactor);
      const tempScaleY = scaleY * (shapetype || scalefactorneed ? scaleFactorY : scaleFactor);
      const tempLeft = left * scaleFactorX;
      const tempTop = top * scaleFactorY;
      if (objects[i].points) {

        objects[i].scaleX = scaleFactorX;
        objects[i].scaleY = scaleFactorY;
        objects[i].left = tempLeft;
        objects[i].top = tempTop;
      } else {
        objects[i].scaleX = tempScaleX;
        objects[i].scaleY = tempScaleY;
        objects[i].left = tempLeft;
        objects[i].top = tempTop;
      }
      objects[i].setCoords();
    }
    canvas.renderAll();
    canvas.calcOffset();
  }

  getbigRectangle(Width, Height) {
    const checkdiff = Width < Height;
    let finalval = Height / Width;
    if (!checkdiff) {
      finalval = Width / Height;
    }
    return Math.abs(finalval) > (1.25);
  }
  setTableConfiguration(element) {
    if (element.ShapeType != undefined) {

      let type;
      switch (element.ShapeType) {
        case 0:
          type = ShapeTypeEnum.Rectangle
          break;
        case 1:
          type = this.checkTableiscircle(element);
          break;
        case 2:
          type = ShapeTypeEnum.Pin
          break;
        case 3:
          type = ShapeTypeEnum.BasicRectangle;
          break;
        case 4:
          type = ShapeTypeEnum.BasicCircle;
          break;
        case 8:
          type = ShapeTypeEnum.Image;
          break;

      }
      let adjustheightval = element.Height;
      let adjustwidthtval = element.Width;
      // const type = 'rect';
      if (type == 'rect') {
        const color = '#f7f7f7';
        const strokeColor = '#95989A';
        const textColor = 'gray';
        const party = null;
        const blocked = false;


        this.rectangle = new fabric.Rect({
          left: element.Left,
          top: element.Top,
          height: adjustheightval,
          width: adjustwidthtval,
          fill: '#fff',
          name: 'shape',
          rx: 2,
          ry: 2,
        });

        this.rectangle.set({
          name: 'shape',
        });

        this.tableObj = [];
        this.tableObj.push(this.rectangle);
        this.addTableGroup(this, this.rectangle, element, party);

      }
      else if (type == 'circle') {

        const party = null;

        this.circle = new fabric.Circle({
          left: element.Left,
          top: element.Top,
          height: adjustheightval,
          width: adjustwidthtval,
          radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
          fill: '#fff',
        });
        this.circle.set({
          name: 'shape',
        });
        this.addTableGroup(this, this.circle, element, party)
      }
      else if (type == ShapeTypeEnum.Ellipse) {
        this.ellipse = new fabric.Ellipse({
          left: element.Left,
          top: element.Top,
          fill: '#fff',
          rx: element.Width / 2,
          ry: element.Height / 2,
        });
        this.ellipse.set({
          name: 'shape',
        });
        this.ellipse.setControlsVisibility({

          'ml': false,
          'mt': false,
          'mr': false,
          'mb': false,

        });
        this.addTableGroup(this, this.ellipse, element, false);
      }
      else if (type == ShapeTypeEnum.Pin) {
        let color = '#000';
        let seatingTypeSelected = this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == element.SeatingTypeId);

        if (seatingTypeSelected.length > 0) {
          let statusColor = seatingTypeSelected[0].Color;
          color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
        }
        this.pin = new fabric.Circle({

          left: element.Left,
          top: element.Top,
          height: adjustheightval,
          width: adjustwidthtval,
          radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
          fill: color,

        });
        this.pin.set({
          name: 'shape',
          type: 'pin'
        });
        this.addTableGroup(this, this.pin, element, false);

      }
      else if (type == ShapeTypeEnum.BasicRectangle) {
        const party = null;
        this.basicRectangle = new fabric.Rect({
          left: element.Left,
          top: element.Top,
          height: adjustheightval,
          width: adjustwidthtval,
          fill: '#fff',
          rx: 2,
          ry: 2
        });

        this.basicRectangle.set({
          name: 'shape',
          type: 'brect'
        });
        this.addTableGroup(this, this.basicRectangle, element, false);
      } else if (type == ShapeTypeEnum.BasicCircle) {
        const party = null;
        this.basicCircle = new fabric.Circle({
          left: element.Left,
          top: element.Top,
          height: adjustheightval,
          width: adjustwidthtval,
          radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
          fill: '#fff',
        });
        this.basicCircle.set({
          name: 'shape',
          type: 'bcircle'
        });
        this.addTableGroup(this, this.basicCircle, element, false)
      }
      else if (type == ShapeTypeEnum.Image) {
        const images = this.customImages.filter((img) => img.ImageId == element.ImageId);
        if (images && images.length == 1) {
          let that = this;
          fabric.Image.fromURL('data:image/png;base64,' + images[0].bytes, function (img) {
            img.set({
              scaleX: adjustwidthtval / img.width,
              scaleY: adjustheightval / img.height,
              top: element.Top * that.scaleFactorY,
              left: element.Left * that.scaleFactorX,
              name: 'shape',
              type: 'image',
            })
            that.addTableGroup(that, img, element, false);
          });
        }
      }

    }
  }

  drawRectangleSeat(obj, that, colorData) {
    const color = '#444444';
    const objectWidth = obj.width;
    const objectHeight = obj.height;
    let setArray;
    const partySize = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
    switch (partySize) {
      case 1:
        setArray = ['left'];
        break;
      case 2:
        setArray = ['left', 'right'];
        break;
      case 3:
        setArray = ['left', 'top', 'right'];
        break;
      case 4:
        setArray = ['left', 'top', 'right', 'bottom'];
        break;
      case 5:
        setArray = ['left', 'top-right', 'top-left', 'right', 'bottom'];
        break;
      case 6:
        setArray = ['left', 'top-right', 'top-left', 'right', 'bottom-left', 'bottom-right'];
        break;
      default:
        break;
    }

    return this.drawSeat(obj, setArray, this, color);
  }

  setSelectedTables(tables) {
    let that = this;
    this.joinTableSelected = [];
    this.selectedTableIds = (this.allowMultipleSelection && !this.communalTableOption) ? this.selectedTableIds : [];
    let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
    control.get('tableId').setValue(this.selectedTableIds);
    if (tables.target.Id) {
      let index = this.selectedTableIds.findIndex(x => x == tables.target.Id);

      if (index != -1) {
        this.selectedTableIds.splice(index, 1)
        let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
        control.get('tableId').setValue(this.selectedTableIds)
        const objs = this.canvas.getObjects();
        let data = objs.filter(x => x.Id == tables.target.Id);
        if (data.length > 0) {
          this.removeHightLightedColor(data[0]);
        }
      }
      else {
        const objs = this.canvas.getObjects();
        objs.forEach(table => {
          if (table.Id) {
            if ((!this.allowMultipleSelection || this.communalTableOption) && tables.target.selectable) {
              (this.joinTableSelected.findIndex(x=>x.Id == table.Id) > -1) || this.removeHightLightedColor(table);
            }
            if (tables.target.Id && table.Id === tables.target.Id && tables.target.selectable &&
              (
                !(tables.target.SeatingTypeId > 0)
                || !(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0)
                || (tables.target.SeatingTypeId > 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id > 0 && tables.target.SeatingTypeId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingType.id)
              ) &&
              (
                !(tables.target.SeatingAreaId > 0)
                || !(this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0)
                || (tables.target.SeatingAreaId > 0 && this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id > 0 && tables.target.SeatingAreaId == this.rs.reservationFormGroup.controls.reservationDetailsForm.value.seatingArea.id)
              )) {

              if (this.allowMultipleSelection && this.selectedTableIds.length > 0) {
                this.selectedTableIds.push(tables.target.Id);
                if (!tables.target.IsCommunalTable && !this.isCommunalTableSelected) {
                  let total = 0;
                  let seaterTables = this.canvas.getObjects().filter(x => x.Id);
                  this.selectedTableIds.forEach(data => {
                    let selectedTable = seaterTables.filter(x => x.Id == data);
                    if (selectedTable.length > 0) {
                      total = selectedTable[0].MaxPartySize + total;
                    }
                  });
                  if (total <= that.partyDetails.partySize) {
                    this.animationCounter = 0;
                    this.rs.reservationFormGroup.get('reservationDetailsForm').get('tableId').setValue(this.selectedTableIds);
                    this.highlightSelectedObject(table);
                  }
                  else {
                    let isPartySizeFulFilled = this.selectedTableIds.slice(0, -1);
                    let seaterTables = this.canvas.getObjects().filter(x => x.Id);
                    let total = 0;
                    isPartySizeFulFilled.forEach(data => {
                      let selectedTable = seaterTables.filter(x => x.Id == data);
                      if (selectedTable.length > 0) {
                        total = selectedTable[0].MaxPartySize + total;
                      }
                    });
                    if (total < that.partyDetails.partySize) {
                      this.animationCounter = 0;
                      let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
                      control.get('tableId').setValue(this.selectedTableIds)
                      this.highlightSelectedObject(table);
                    }
                    else {
                      this.selectedTableIds.forEach(tableData => {
                        let tableDetails = objs.filter(x => x.Id == tableData)[0]
                        this.removeHightLightedColor(tableDetails)
                      })
                      this.selectedTableIds = [];
                      this.selectedTableIds.push(tables.target.Id);
                      this.animationCounter = 0;
                      let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
                      control.get('tableId').setValue(this.selectedTableIds)
                      this.highlightSelectedObject(table);
                    }
                  }
                }
                else {
                  this.selectedTableIds = this.selectedTableIds.slice(0, -1);
                }
              }
              else {
                this.joinTableSelected = this.isJoinedTableAvailable(tables.target.Id);
                if (this.joinTableSelected && this.joinTableSelected.length > 0 && !this.allowMultipleSelection) {
                  let joinedTableIds = this.joinTableSelected.map(x => { return x.Id })
                  this.selectedTableIds = [...joinedTableIds];
                  this.selectedTableIds.forEach(tbleId => {
                    this.highlightSelectedObject(objs.filter(tbleObj => tbleObj.Id == tbleId)[0]);
                  });
                }
                else {
                  this.selectedTableIds.push(tables.target.Id);
                  this.highlightSelectedObject(tables.target)
                }

                this.isCommunalTableSelected = tables.target.IsCommunalTable ? true : false;
                this.animationCounter = 0;
                let control = this.rs.reservationFormGroup.get('reservationDetailsForm');
                control.get('tableId').setValue(this.selectedTableIds)

              }

            }
          }
        });
      }
    }
  }

  removeHightLightedColor(object) {
    if (object.ShapeType == 2) {
      object._objects.filter(x => x.name == 'shape')[0].set({
        fill: object.defaultColor,
        strokeWidth: 0
      });
    }
    else {
      object._objects.filter(x => x.name == 'textCircle')[0].set({
        fill: object.defaultColor,
        strokeWidth: 0
      });
    }

  }

  highlightSelectedObject(object) {

    if (object.ShapeType == 2) {
      object._objects.filter(x => x.name == 'shape')[0].set({
        fill: '#F27106',
        stroke: '#fff',
        strokeWidth: 4
      });
    }
    else {
      object._objects.filter(x => x.name == 'textCircle')[0].set({
        fill: '#F27106',
        stroke: '#fff',
        strokeWidth: 4
      });
    }

  }

  drawSeat(obj, seatArray, that, color) {
    const tableObj = [];
    const scale = obj._objects.filter(x => x.name == 'shape')[0].scaleX;
    const shape = obj._objects.filter(x => x.name == 'shape')[0]
    seatArray.forEach(element => {
      switch (element) {
        case 'top': {
          const ff = this.rectSeat(obj.left - (obj.width / 4), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 4), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'left': {
          const ff = this.rectSeat((obj.left - (obj.width / 2) - 4), (obj.top - (obj.height / 4) - 4), (obj.left - (obj.width / 2) - 4), (obj.top + obj.height / 4), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'right': {
          const ff = this.rectSeat((obj.left + (obj.width / 2) - 1), (obj.top - (obj.height / 4) - 4), (obj.left + (obj.width / 2) - 1), (obj.top + obj.height / 4), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'bottom': {
          const ff = this.rectSeat((obj.left - (obj.width / 4)), (obj.top + (obj.height / 2)), obj.left + (obj.width / 4), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'top-right': {
          const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'top-left': {
          const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'bottom-right': {
          const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
        }

        case 'bottom-left': {
          const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
        }
      }

    });
    return tableObj;
  }

  rectSeat(x1, y1, x2, y2, scale, color) {
    scale = 1;
    const rectangleSeatObj = new fabric.Line([x1, y1, x2, y2], {
      stroke: color,
      strokeWidth: (5),
    });
    rectangleSeatObj.set({
      name: 'seat'
    });
    return rectangleSeatObj;
  }

  checkTableiscircle(object) {
    const checkdiff = object.Width - object.Height;
    return Math.abs(checkdiff) < 15 ? ShapeTypeEnum.Circle : ShapeTypeEnum.Ellipse;
  }



  findmaxObject(tables?, labels?, walls?, shapes?) {
    const afternewtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
    const afternewlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
    const afternewwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
    const afternewshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

    const allObjects = _.cloneDeep(afternewtables.concat(afternewlabels, afternewwalls, afternewshapes));

    allObjects.forEach(element => {
      if (element.tempname == 'wall') {
        const maxx = _.maxBy(element.Points, (e) => { return e['X']; });
        const maxy = _.maxBy(element.Points, (e) => { return e['Y']; });
        element.totalDataHeight = maxy['Y'] + 10;
        element.totalDataWidth = maxx['X'] + 10;
      }
      else if (element.tempname == 'label') {
        const findstringlength = element.Text.length;
        let getwidth = 11;
        let getHeight = 11;
        const angles = element.Angle;
        if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
          getwidth = findstringlength * 10.2 / 2;
        } else {
          getHeight = findstringlength * 10.2 / 2;
        }
        element.totalDataHeight = getHeight + element.Top;
        element.totalDataWidth = getwidth + element.Left;
      }
      else if (element.tempname == 'table') {
        element.totalDataHeight = (element.Height) + element.Top;
        element.totalDataWidth = (element.Width) + element.Left;
      } else if (element.tempname == 'area') {
        element.totalDataHeight = element.Height + element.Top + 15;
        element.totalDataWidth = element.Width + element.Left + 15;
      } else {
        element.totalDataHeight = element.Height / 2 + element.Top;
        element.totalDataWidth = element.Width / 2 + element.Left;
      }

    });

    return allObjects;
  }

  findminObject(tables?, labels?, walls?, shapes?) {
    const newtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
    const newlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
    const newwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
    const newshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

    const allObjects = _.cloneDeep(newtables.concat(newlabels, newwalls, newshapes));
    allObjects.forEach(element => {
      if (element.tempname == 'wall') {
        const minx = _.minBy(element.Points, (e) => { return e['X']; });
        const miny = _.minBy(element.Points, (e) => { return e['Y']; });
        element.totalminDataHeight = miny['Y'];
        element.totalminDataWidth = minx['X'];
      }
      else if (element.tempname == 'label') {
        const findstringlength = element.Text.length;
        let getwidth = 2;
        let getHeight = 2;
        const angles = element.Angle;
        if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
          getwidth = findstringlength / 2;
        } else {
          getHeight = findstringlength / 2;
        }
        element.totalminDataHeight = element.Top - (getHeight);
        element.totalminDataWidth = element.Left - (getwidth);
      }
      else if (element.tempname == 'table') {
        element.totalminDataHeight = element.Top - ((element.Height / 2) + 14);
        element.totalminDataWidth = element.Left - ((element.Width / 2) + 14);
      } else if (element.tempname == 'area') {
        element.totalminDataHeight = element.Top;
        element.totalminDataWidth = element.Left;
      } else {
        element.totalminDataHeight = element.Top - element.Height;
        element.totalminDataWidth = element.Left - element.Width;
      }
    });

    return allObjects;

  }

  addTableGroup(that, object, element, party) {
    let blocked = false;
    that.tableObj = [];
    const statusColorData = this.getStatusColor(element)
    if (object.type != ShapeTypeEnum.Pin) {
      object.set('fill', '#666666');
    }

    if (element.selected) {
      object.set({
        fill: 'red',
      });

    }
    if (object.type == ShapeTypeEnum.Image) {
      object.set('stroke', statusColorData.fillColor);
      object.set('strokeWidth', 2);
    }

    that.tableObj.push(object);
    that.groupedObject = new fabric.Group(that.tableObj, {
      top: object.top,
      left: object.left,
      originY: 'center',
      originX: 'center',
    });

    let seatingTypeSelected = this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == element.SeatingTypeId);
    let color = '#000'
    if (seatingTypeSelected.length > 0) {
      let statusColor = seatingTypeSelected[0].Color;
      color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
    }
    that.groupedObject.set({
      SeatingArea: element.SeatingArea,
      SeatingAreaId: element.SeatingAreaId,
      SeatingType: element.SeatingType,
      SeatingTypeId: element.SeatingTypeId,
      ServerId: element.ServerId,
      MaxPartySize: element.MaxPartySize,
      MinPartySize: element.MinPartySize,
      Name: element.Name,
      Price: element.Price,
      IsAvailableForBooking: element.IsAvailableForBooking,
      IsAvailableForReservations: element.IsAvailableForReservations,
      IsCommunalTable: element.IsCommunalTable,
      FloorPlanViewId: element.FloorPlanViewId,
      Id: element.Id,
      ShapeType: element.ShapeType,
      Party: statusColorData.partyData,
      selectable: !element.IsAvailableForReservations || !element.IsAvailableForBooking || element.MinPartySize > this.partyDetails.partySize ? false : true,
      radius: element && element.radius > 0 ? element.radius : object.width / 2,
      Angle: element ? element.RotationAngle : 0,
      defaultColor: color,
      ImageId: element ? element.ImageId : null,
      EventId: element ? element.EventId : null

    });
    if (!element.IsAvailableForReservations || !element.IsAvailableForBooking || element.MinPartySize > this.partyDetails.partySize || element.EventId > 0) {
      color = '#808080';
      object.set({
        selectable: false,
        fill: '#808080',
        opacity: 1
      });
      that.groupedObject.set({
        defaultColor: '#808080'
      })
    }
    if (object.type == 0 || object.type == ShapeTypeEnum.Rectangle) {
      const seatData = this.drawRectangleSeat(that.groupedObject, that, '#3B4532');
      seatData.forEach(seat => {
        seat.set('strokeWidth', seat.strokeWidth * that.groupedObject.scaleX)
        that.groupedObject.addWithUpdate(seat);
        seat.moveTo(that.groupedObject.size() - 5)
      });
    }
    else if (object.type == 1 || object.type == ShapeTypeEnum.Circle) {
      const obj = _.cloneDeep(that.groupedObject)
      const seatData = this.drawCircleSeat(obj, that, '#3B4532');
      seatData.forEach(seat => {
        that.groupedObject.addWithUpdate(seat);
        seat.moveTo(that.groupedObject.size() - 5)
      });
    }

    that.groupedObject.setCoords();
    let text1;
    text1 = new fabric.Text('+', {
      fill: '#D5D5D5',
      textAlign: 'center',
      fontSize: 14,
      originX: 'center',
      originY: 'center',
      name: 'text',
      fontWeight: 'bold',
      top: that.groupedObject.top,
      left: that.groupedObject.left
    });

    const numberCircle = new fabric.Circle({
      fill: color,
      radius: 14,
      top: that.groupedObject.top,
      left: that.groupedObject.left,
      originX: 'center',
      originY: 'center',
      name: 'textCircle',
      opacity: .8,
    });
    if (object.type == ShapeTypeEnum.Pin) {
      text1 = new fabric.Text('+', {
        textAlign: 'center',
        fill: '#fff',
        name: 'pin',
        top: that.groupedObject.top,
        left: that.groupedObject.left,
        originX: 'center',
        originY: 'center',
        fontWeight: 'bold',
        objectCaching: false,
        fontSize: object.radius
      });
    }
    if (object.type != ShapeTypeEnum.Pin) {
      that.groupedObject.addWithUpdate(numberCircle);
    }

    that.groupedObject.addWithUpdate(text1)

    if (element) {
      that.groupedObject.rotate(element.RotationAngle);
    }
    that.groupedObject.addWithUpdate();

    if (element && element.scaleX) {
      let tempScaleX = element.scaleX;

      if (tempScaleX == 0 || tempScaleX < 0.1) {
        tempScaleX = 1;
        that.groupedObject.set({
          scaleX: tempScaleX
        })
      }

    }

    if (element && element.scaleY) {
      let tempScaleY = element.scaleY;

      if (tempScaleY == 0 || tempScaleY < 0.1) {
        tempScaleY = 1;
        that.groupedObject.set({
          scaleY: tempScaleY
        })
      }

    }

    if (object.type == ShapeTypeEnum.Image) {
      if (element && element.Angle) {
        that.groupedObject.set({
          angle: element.Angle
        })
      }
    }

    that.groupedObject.setCoords();
    that.count++;
    that.canvas.add(that.groupedObject);

  }

  drawCircleSeat(obj, that, colorData) {
    const color = '#444444';
    const seatWidth = 5 * 5;
    const radius = obj.radius;
    return this.roundSeatDraw(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, 'green', this, obj, color); // green,blue
  }

  roundSeatDraw(seat, radius, seatColor, tblFillColor, that, obj, color?) {
    const seatWidth = seat * 25;
    const lastend = 0;
    const myTotal = seat * 8;
    let startAngle = 0;
    const tableObj1 = [];
    const strokeColor = '';
    const table = obj._objects.filter(x => x.name == 'shape')[0];
    for (let i = 0; i < seat; i++) {
      const circleSeat = new fabric.Circle({
        radius: ((table.width * table.scaleX) / 2) + 3,
        startAngle: startAngle - ((Math.PI * 2) / myTotal),
        endAngle: startAngle + ((Math.PI * 2) / myTotal),
        stroke: seatColor,
        strokeWidth: (5),
        fill: '',
        top: obj.top,
        left: obj.left,
        originX: 'center',
        originY: 'center',
      });

      circleSeat.set({
        name: 'seat',
      });

      startAngle += Math.PI * 2 * ((myTotal / seat) / myTotal);
      tableObj1.push(circleSeat);
    }
    return tableObj1;
  }

  getStatusColor(element) {
    let fillColor = '#f2f2f2';
    const textColor = '#444444';
    let partyColor = 'black';
    let stroke = '#3B4532';
    let numberColor = '#4f483e';
    let partyData = null;
    return ({ fillColor, textColor, partyData, partyColor, stroke, numberColor });
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  selectedTable(obj, ismouseDowm?) {
    const objs = this.canvas.getObjects();
    objs.forEach(object => {
      if (object._objects) {
        object._objects.forEach(element => {
          if (element.name == 'seat') {
            element.set({
              stroke: '#444444',
            })
          }
          if (element.name == 'shape') {
            element.set({
              stroke: null
            })

          }


        });
      }
    });
    obj.target._objects.forEach(element => {
      if (element.name == 'seat') {
        element.set({
          fill: 'red'
        })
      }
      if (element.name == 'shape') {
        element.set({
          fill: 'red'
        })

      }
    });
  }

}
